"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const iconMap = {
  heart: _icons.Heart,
  truck: _icons.Truck,
  settings: _icons.Settings,
  network: _icons.Network,
  education: _icons.Education,
  editorial: _icons.Editorial,
  products: _icons.Products,
  discount: _icons.DiscountTag,
  conference: _icons.Conference,
  wallet: _icons.Wallet,
  sales: _icons.Sales,
  gift: _icons.Gift,
  info: _icons.InfoCircle,
  welcome: _icons.WelcomeKit,
  pbs: _icons.Pbs,
  academy: _icons.Academy,
  rewardsHearts: _icons.RewardsHearts
};
const Icon = (0, _mui.styled)('svg')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: theme.spacing(5)
}));
const NotificationIcon = ({
  iconId,
  ...props
}) => {
  const iconType = iconId === null || iconId === undefined ? null : iconMap[iconId];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
    as: iconType ?? _icons.Products,
    ...props
  });
};
exports.NotificationIcon = NotificationIcon;
